import { makeStyles } from "tss-react/mui";
import { keyframes } from "@emotion/react";

const pulsate = keyframes`
  0% {
    transform: scale(0.95);
    opacity: 0.8;
  }
  50% {
    transform: scale(1.05);
    opacity: 1;
  }
  100% {
    transform: scale(0.95);
    opacity: 0.8;
  }
`;

// const rotate = keyframes`
//   from {
//     transform: rotate(0deg);
//   }
//   to {
//     transform: rotate(360deg);
//   }
// `;

const useStyles = makeStyles()((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100vh",
    width: "100vw",
    backgroundColor: "#f4f6fa", // Clean, matching background
    position: "fixed",
    top: 0,
    left: 0,
    zIndex: 10000,
  },
  logoWrapper: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    animation: `${pulsate} 2s ease-in-out infinite`,
  },
  spinner: {
    position: "absolute",
    width: "80px !important",
    height: "80px !important",
    color: theme.palette.primary.main,
    opacity: 0.3,
  },
  logo: {
    zIndex: 1,
    width: "50px !important",
    height: "50px !important",
  },
  text: {
    marginTop: "24px",
    fontFamily: "Poppins",
    fontWeight: 500,
    fontSize: "14px",
    color: "#4D1277",
    letterSpacing: "0.5px",
    opacity: 0.8,
  },
  recoveryBox: {
    marginTop: "32px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "16px",
    animation: `${pulsate} 2s ease-in-out infinite`,
  },
  recoveryText: {
    fontFamily: "Poppins",
    fontWeight: 500,
    fontSize: "14px",
    color: "#ff4d4d",
    textAlign: "center",
    maxWidth: "300px",
  },
  buttonGroup: {
    display: "flex",
    gap: "12px",
  },
  button: {
    textTransform: "none",
    fontFamily: "Poppins",
    fontWeight: 600,
    padding: "8px 24px",
    borderRadius: "8px",
    backgroundColor: theme.palette.primary.main,
    color: "#ffffff",
    "&:hover": {
      backgroundColor: theme.palette.primary.dark,
    },
  },
}));

export default useStyles;
